import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M.75 9.75V6a5.25 5.25 0 1 1 10.5 0v3.75m10.5 0H8.25a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-10.5a1.5 1.5 0 0 0-1.5-1.5"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      d: "M15 16.5a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75"
    }, null, -1)
  ]));
}
const interfaceLockOpenUnlock = { render };
export {
  interfaceLockOpenUnlock as default,
  render
};
//# sourceMappingURL=interface-lock-open-unlock.svg.js.map
